module.exports = __webpack_public_path__ + "static/media/summer-garden.209445bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plants/summer-garden.jpg
// module id = 733
// module chunks = 13